import { makeAssistantToolUI } from '@assistant-ui/react'

/**
 * Register a tool name so its call/result renders nothing in the thread.
 * Use for tools the LLM calls for its own reasoning where a visible block
 * would add noise (e.g. `get_node_details`, internal lookups).
 */
export function makeHiddenToolUI(toolName: string) {
  return makeAssistantToolUI<unknown, unknown>({
    toolName,
    render: () => null,
  })
}

export const GetNodeDetailsToolUI = makeHiddenToolUI('get_node_details')
/** The agent's own look-up of labels / relationship types / property keys — reasoning, not a result. */
export const DescribeGraphSchemaToolUI = makeHiddenToolUI('describe_graph_schema')
